// extracted by mini-css-extract-plugin
export default {"container":"BookFacilities_container__Mga5i"};